//hooks
import UseModeratedComment from "./ModeratedComment.hooks";

//interfaces
import { UserActivity } from "@/interfaces/activityFeed";
import { IModeratedCommentActivity } from "@/interfaces/activityFeedNotifications";

//components
import { ActionFeedbackBanner } from "thrive-components";
import ActivityProfileData from "../../elements/activityProfileData/ActivityProfileData";
import ModeratedCommentTitle from "../../elements/notificationTitle/ModeratedCommentTitle/ModeratedCommentTitle";
import Complaint from "../../elements/userComment/Complaint";
import UserComment from "../../elements/userComment/UserComment";
import ActivityInformationPanel from "../../elements/activityInformationPanel/ActivityInformationPanel";
import DeletedBanner from "../../elements/deletedComment/DeletedComment";
import DeleteComment from "../../elements/deleteComment/DeleteComment";
import DeleteCommentButton from "../../elements/deleteComment/DeleteCommentButton";

//styling
import "../../../../../css/activityFeed/notifications/comment-activity.scss";



const ModeratedComment = ({ zIndexNum, activityId, isPopOut = false, timeStamp, dateStamp, userWhoFlagged, content, comment, meta, appDetails, onDeleteCommentClick, onLikeClick, getOpenOnWebLink, notificationDetails}: IModeratedCommentActivity) => {
    const {showDeleteFunctionality, commentClassName, handleLikeClick, commentTruncate, hideMenu, userCommentIsLiked, showFeedbackBanner, feedbackType,feedbackMessage, deletedBannerMessage, showDeletedBanner, showDeleteCommentButton, activityInfo, onDelete, onShowDeleteFunctionalityClick, onHideDeleteFunctionality} = UseModeratedComment({activityId, isPopOut, timeStamp, dateStamp, comment, content, appDetails, meta, onLikeClick, onDeleteCommentClick, notificationDetails});
  
    return (
        <div className={`${isPopOut ? "" : "comment-notification-full"} flagged-comment-notification comment-notification notification-wrapper`} data-testid={"flagged-comment-user-activity"}>
            <div className="top-row">
                <ActivityProfileData 
                    imageUrl={comment.commentAuthor.imageUrl}
                    isPopOut={isPopOut}
                    userActivity={UserActivity.moderatedComment} 
                    timeStamp={timeStamp}
                    dateStamp={dateStamp}
                />
                
                <ModeratedCommentTitle 
                    content={content} 
                    commentAuthor={comment.commentAuthor.name} 
                    userWhoFlagged={userWhoFlagged.name}                
                />
            </div>        
            
            <Complaint 
                zIndex={zIndexNum} 
                isPopOut={isPopOut} 
                complaintText={comment.objectionableMessage}    
            />

            <UserComment 
                zIndexNum={zIndexNum} 
                className={commentClassName} 
                commentText={comment.commentText} 
                truncateNumber={commentTruncate} 
                onLikeClick={handleLikeClick} 
                isLiked={userCommentIsLiked} 
                getWebLink={getOpenOnWebLink} 
                onDeleteClick={onShowDeleteFunctionalityClick} 
                isReply  
                hideMenu={hideMenu}
            />
            
            {showFeedbackBanner && 
                <ActionFeedbackBanner 
                    feedbackType={feedbackType} 
                    feedbackMessage={feedbackMessage} 
                />
            }

            {showDeletedBanner &&
                <DeletedBanner 
                        isDeleted
                        message={deletedBannerMessage}
                />
            } 

            {showDeleteFunctionality && 
                <DeleteComment 
                    isInlineStyle={isPopOut} 
                    showModal={showDeleteFunctionality} 
                    onCloseClick={onHideDeleteFunctionality} 
                    onConfirmClick={onDelete} 
                />
            }

            {showDeleteCommentButton && 
                <DeleteCommentButton 
                    onShowDeleteFunctionalityClick={onShowDeleteFunctionalityClick} 
                />
            }
            
            <ActivityInformationPanel 
                {...activityInfo}
            />
        </div>
    )
};

export default ModeratedComment